module.exports = __webpack_public_path__ + "img/shape-5_yellow-400.1003b84.png";